module.exports = __webpack_public_path__ + "img/technical.3ec5e078.png";